<template>
  <div class="header-video" :style="cssVariables">
    <video
      v-if="videoUrl.desktop"
      autoplay
      loop
      muted
      playsinline
      class="d-none d-md-block video-desktop img-fluid"
      :height="commonHeight"
      aria-label="cover video"
    >
      <source :src="videoUrl.desktop" type="video/mp4" />
    </video>
    <video
      v-if="videoUrl.mobile"
      autoplay
      loop
      muted
      playsinline
      class="d-md-none"
      :height="commonHeight"
      aria-label="cover video"
    >
      <source :src="videoUrl.mobile" type="video/mp4" />
    </video>
    <picture v-if="!videoUrl.desktop && !videoUrl.mobile">
      <source media="(min-width: 768px)" :srcset="fallbackImage.desktop.url" />
      <img
        width="1000"
        :height="commonHeight"
        class="img-fluid"
        :src="fallbackImage.mobile.url"
        :alt="fallbackImage.mobile.url || fallbackImage.desktop.url"
        loading="lazy"
      />
    </picture>

    <div class="content container-md p-0">
      <div class="texts p-3 p-md-0">
        <prismic-rich-text
          :class="`heading ${headingSizesDict[title[0].type]}`"
          :field="title"
        ></prismic-rich-text>
        <prismic-rich-text :field="description"></prismic-rich-text>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      title: '',
      description: '',
      videoUrl: {
        mobile: '',
        desktop: ''
      },
      textColor: '',
      fallbackImage: {},
      headingSizesDict: {
        heading1: 'display-4',
        heading2: 'h2',
        heading3: 'h3',
        heading4: 'h4',
        heading5: 'h5',
        heading6: 'h6'
      },
      commonHeight: 600
    };
  },
  computed: {
    cssVariables() {
      return `
        --text-color: ${this.textColor};
        --bg-color-mobile: ${this.bgColorMobile};
      `;
    }
  },
  created() {
    this.title = this.slice.primary.title1;
    this.description = this.slice.primary.description;
    this.videoUrl = {
      desktop: this.slice.primary.video_desktop.url,
      mobile: this.slice.primary.video_mobile.url
    };
    this.textColor = this.slice.primary.text_color;
    this.bgColorMobile = this.slice.primary.bg_color_mobile;
    this.fallbackImage = {
      desktop: this.slice.primary.fallback_image_desktop,
      mobile: this.slice.primary.fallback_image_mobile
    };
  }
};
</script>

<style lang="scss" scoped>
.header-video {
  margin: 0 -15px 0 -15px;
  display: grid;
  color: var(--text-color);

  @include min-xl4 {
    max-width: 1920px;
    margin: auto;
  }

  video {
    width: 100%;
    object-fit: cover;
  }

  img {
    width: 100%;
    object-fit: cover;
  }
  @include min-md {
    img,
    picture {
      grid-area: 1/1;
    }
  }

  .video-desktop {
    grid-area: 1/1;
  }

  .content {
    display: grid;
    background-color: var(--bg-color-mobile);

    @include min-md {
      grid-area: 1/1;
      background-color: transparent;
    }

    .texts {
      display: grid;
      gap: 0.5rem;
      align-content: center;

      ::v-deep .heading > * {
        font-size: inherit;
      }
    }

    @include min-md {
      .texts {
        max-width: 50%;
        margin-left: auto;
      }
    }
  }
}
</style>
